import { Fragment, useState, useEffect } from "react";
import { Stepper, Step } from "react-form-stepper";
import RYStepOne from "./register-yourself/RYStepOne.jsx";
import RYStepTwo from "./register-yourself/RYStepTwo.jsx";
import logo from "../../../../assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { getDiseasesAction } from "../../../../store/actions/DiseasesAction";
import { createRegisterAction } from "../../../../store/actions/RegisterActions";
import FormSuccessMessage from "../../Common/FormSuccessMessage";

const occupationOptions = [
  { value: "Doctor", label: "Doctor" },
  { value: "Nurse", label: "Nurse" },
  { value: "Engineer", label: "Engineer" },
  { value: "Teacher", label: "Teacher" },
  { value: "Farmer", label: "Farmer" },
  { value: "Housewife", label: "Housewife" },
  { value: "Student", label: "Student" },
  { value: "Businessman", label: "Businessman" },
  { value: "Driver", label: "Driver" },
  { value: "Electrician", label: "Electrician" },
  { value: "Plumber", label: "Plumber" },
  { value: "Carpenter", label: "Carpenter" },
  { value: "Lawyer", label: "Lawyer" },
  { value: "Police Officer", label: "Police Officer" },
  { value: "Artist", label: "Artist" },
  { value: "Actor", label: "Actor" },
  { value: "Scientist", label: "Scientist" },
  { value: "Retired", label: "Retired" },
  { value: "Unemployed", label: "Unemployed" },
  { value: "Other", label: "Other" },
];

const RegisterYourSelf = () => {
  const dispatch = useDispatch();
  const diseases = useSelector((state) => state.diseases.diseases || [""]);
  const [goSteps, setGoSteps] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    lastname: "",
    contact_number: "",
    email: "",
    gender: "",
    disease_id: "",
    date_of_birth: "",
    height: "",
    weight: "",
    occupation: "",
  });

  useEffect(() => {
    dispatch(getDiseasesAction());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTextDateChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      date_of_birth: convertDateToDDMMYYYY(value),
    }));
  };

  const convertDateToDDMMYYYY = (inputDate) => {
    if (!inputDate) return "";
    const [year, month, day] = inputDate.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await dispatch(createRegisterAction(formData));
      if (result?.register_id) {
        setIsSubmitted(true);
      }
    } catch (error) {
      console.error("Registration failed:", error);
    }
  };

  const handleDiseasesChange = (selectedOption) => {
    handleChange({
      target: {
        name: "disease_names",
        value: selectedOption ? selectedOption.value : "",
      },
    });
  };

  const validateStepOne = () => {
    const requiredFields = [
      "first_name",
      "middle_name",
      "lastname",
      "contact_number",
      "email",
    ];

    for (let field of requiredFields) {
      if (!formData[field] || formData[field].trim() === "") {
        alert(`Please fill out the ${field.replace("_", " ")} field.`);
        return false;
      }
    }

    return true;
  };

  // Show success message if form was submitted successfully
  if (isSubmitted) {
    return (
      <FormSuccessMessage
        title="Registered successfully. Thank you!"
        message="Your registration has been completed successfully. Please check your email for further details."
      />
    );
  }

  return (
    <Fragment>
      <div className="h-100 p-meddle">
        <div className="container h-100">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-md-12 col-lg-6"></div>
            <div className="row justify-content-center align-items-center">
              <div className="col-md-12 col-lg-6 align-items-center">
                <img
                  src={logo}
                  alt="Logo"
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12 col-xxl-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Register Yourself</h4>
                  </div>
                  <div className="card-body">
                    <div className="form-wizard ">
                      <Stepper
                        className="nav-wizard"
                        activeStep={goSteps}
                        label={false}
                      >
                        <Step
                          className="nav-link"
                          onClick={() => setGoSteps(0)}
                        />
                        <Step
                          className="nav-link"
                          onClick={() => setGoSteps(1)}
                        />
                      </Stepper>

                      {goSteps === 0 && (
                        <>
                          <RYStepOne
                            formData={formData}
                            handleChange={handleChange}
                            handleDiseasesChange={handleDiseasesChange}
                            diseases={diseases}
                          />
                          <div className="text-end toolbar toolbar-bottom p-2">
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                if (validateStepOne()) {
                                  setGoSteps(1);
                                }
                              }}
                            >
                              Next
                            </button>
                          </div>
                        </>
                      )}

                      {goSteps === 1 && (
                        <>
                          <RYStepTwo
                            formData={formData}
                            handleTextDateChange={handleTextDateChange}
                            handleChange={handleChange}
                            occupationOptions={occupationOptions}
                          />
                          <div className="text-end toolbar toolbar-bottom p-2">
                            <button
                              className="btn btn-secondary me-2"
                              onClick={() => setGoSteps(0)}
                            >
                              Prev
                            </button>
                            <button
                              className="btn btn-primary"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RegisterYourSelf;
